export type PageItem = number | "ellipsis";

/** Номера страниц с многоточием для длинных списков. */
export function buildPageNumbers(
  current: number,
  last: number,
  delta = 1,
): PageItem[] {
  if (last <= 1) return last === 1 ? [1] : [];
  if (last <= 7) {
    return Array.from({ length: last }, (_, index) => index + 1);
  }

  const pages = new Set<number>([1, last]);

  for (let page = current - delta; page <= current + delta; page += 1) {
    if (page >= 1 && page <= last) pages.add(page);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result: PageItem[] = [];

  for (let index = 0; index < sorted.length; index += 1) {
    const page = sorted[index];
    const previous = sorted[index - 1];

    if (previous !== undefined && page - previous > 1) {
      result.push("ellipsis");
    }

    result.push(page);
  }

  return result;
}
